import React from 'react';
import PropTypes from 'prop-types';
import { Links } from './Links';

const TechFeatures = ({ title, features }) => {
  return (
    <div className="scalable-content-section technology-features-section content-wrapper">
      <h2 className="technology-features__column">{title}</h2>
      {features.map((feature, i) => {
        return (
          <div
            key={`technology-features__feature-${i}`}
            className="technology-features__feature"
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6">
                <div dangerouslySetInnerHTML={{ __html: feature.content }} />
                <Links links={feature.links} />
              </div>
              <div className="technology-features__image col-xs-12 col-sm-12 col-md-6">
                <img className="hide-mobile" src={feature.desktopImageUrl} />
                <img className="hide-tablet" src={feature.mobileImageUrl} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

TechFeatures.propTypes = {
  title: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      links: PropTypes.array,
      mobileImageUrl: PropTypes.string,
      desktopImageUrl: PropTypes.string,
    })
  ),
};

export default TechFeatures;
